import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 's1-card',
  templateUrl: './s1-card.component.html',
  styleUrls: ['./s1-card.component.scss']
})
export class S1Card implements OnInit {

  @Input() title: string;
  @Input() headerStyle: string = "bg-dark text-light";
  @Input() cardStyle: string = "";

  constructor() { }

  ngOnInit(): void {
  }

}
